import { proxy } from 'valtio';
import { PersistenceStorage } from '@store/persistence';
import type { SearchHistoryStoreState } from './schema';
import { SearchHistoryStoreSchema } from './schema';

const version = '1.2';
const storageKey = `search-history-${version}`;

export const SearchHistoryPersistence = PersistenceStorage({
  schema: SearchHistoryStoreSchema,
  key: storageKey,
});

export const searchHistoryStoreState = proxy<SearchHistoryStoreState>({
  history: [],
});
